export const LOGO_STATIC_URI = require('../../assets/images/vLogo.png');
export const BACKGROUND_IMAGE = require('../../assets/images/trag.gif');
export const MOBILE_BACKGROUND_IMAGE = require('../../assets/images/mobile-bg.png');
export const PROV_CARD_BG_WALLPAPER = require('../../assets/images/cert.png');
export const CERT_BG_IMAGE = require('../../assets/images/app-banner.png');
export const PROFILE_CARD_BG = require('../../assets/images/profile-card-sm.png');
export const TIMELINE_BACKGROUND_IMAGE = require('../../assets/images/timeline-bg.png')

